import styles from './Divider.module.scss';

export type DividerProps = {
  variant?: 'warm' | 'cold' | 'solid';
  classes?: string;
};

const Divider = ({ variant = 'cold', classes }: DividerProps) => {
  return <hr className={`${styles.divider} ${styles[variant]} ${classes}`} />;
};

export default Divider;
